import { createAsyncThunk } from '@reduxjs/toolkit';
import { getErrorPayload } from '@application/helpers/api-helper';
import PeopleInterestsApi from '@infrastructure/people-interests-api';
export const createPeopleInterestAsync = createAsyncThunk('peopleInterests/create', async (payload, { rejectWithValue }) => {
    try {
        const response = await PeopleInterestsApi.createPeopleInterest(payload);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const updatePeopleInterestAsync = createAsyncThunk('peopleInterests/update', async (payload, { rejectWithValue }) => {
    try {
        const response = await PeopleInterestsApi.updatePeopleInterest(payload);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const deletePeopleInterestAsync = createAsyncThunk('peopleInterests/delete', async (id, { rejectWithValue }) => {
    try {
        const response = await PeopleInterestsApi.deletePeopleInterest(id);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getPeopleInterestByIdAsync = createAsyncThunk('peopleInterests/getById', async (id, { rejectWithValue }) => {
    try {
        const response = await PeopleInterestsApi.getPeopleInterestById(id);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getPeopleInterestsByPeopleIdAsync = createAsyncThunk('peopleInterests/getByPeopleId', async (payload, { rejectWithValue }) => {
    try {
        const response = await PeopleInterestsApi.getPeopleInterestsByPeopleId(payload);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
